import { Server } from '@wajeez-web/core/api-base';
import { ThunkStatus } from '@wajeez-web/stores/base';

export interface ContentEntityTypeState {
  data: Server.ContentEntityTypeOutput[] | null;
  lookups: Server.ContentEntityTypeLookUpWithFieldsOutput[];
  details: Server.ContentEntityTypeDetailedOutput | null;
  modalDetails: Server.ContentEntityTypeDetailedOutput | null;
  status: ThunkStatus;
  updatingStatus: ThunkStatus;
  modalStatus: ThunkStatus;
  navigations: {
    data: Server.DashboardContentEntityTypeNavigationOutput[];
    status: ThunkStatus;
  };
  selectSortFactors: {
    data: Server.ContentEntitiesFactorsOutput | null;
    status: ThunkStatus;
  };
  createMultilingual: {
    data: number | null;
    status: ThunkStatus;
  };
  editMultilingual: {
    data: number | null;
    status: ThunkStatus;
  };
  byIdMultilingual: {
    data: Server.ContentEntityTypeDetailedMultilingualOutput | null;
    status: ThunkStatus;
  };
  datatable: {
    data: Server.TableOfContentEntityTypeColumns | null;
    status: ThunkStatus;
  };
}

export enum ContentEntityType {
  POEM = 'POEM',
}
